<template>
  <app-header
    variant="empty"
    container-class="container-fluid  px-md-5 d-flex align-items-center justify-content-between"
  >
    <template #brand>
      <brand-logo
        to="/home"
        img-class="el-scale"
        img-style="max-height: 52px; max-width: 129px"
        :fallback-src="fallbackLogo"
      />
    </template>

    <template #center>
      <div class="position-absolute start-50 translate-middle-x">
        <button
          type="button"
          class="btn bg-secondary border-0 bg-opacity-05 d-flex align-items-center py-3 px-4"
          data-bs-target="#MagicRemoteJoystick"
          aria-controls="MagicRemoteJoystick"
          data-bs-toggle="offcanvas"
        >
          <icon-component :lib="'material'" :icon="'settings_remote'"></icon-component>
          <span class="ms-2" v-t="'magic_remote.buttons.global'"></span>
        </button>
      </div>
    </template>

    <template #actions>
      <div class="d-flex align-items-center justify-content-end fs-4">
        <btn-audio class="me-3"></btn-audio>
        <btn-home
          v-if="$route.name !== 'home'"
          @gohome="$router.replace({ name: 'home' })"
        ></btn-home>
        <language-switcher class="d-inline-block ms-3"></language-switcher>
        <span class="m-0 p-0 ms-3">{{ time }}</span>
      </div>
    </template>
  </app-header>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { getFullTimeFormat } from "@/services/date-time/date-converter";

import AppHeader from "./app-header.vue";
import BrandLogo from "./brand-logo.vue";
import LanguageSwitcher from "../language-switcher.vue";
import BtnHome from "../buttons/btn-home.vue";
import BtnAudio from "../buttons/btn-audio.vue";
import IconComponent from "../_shared/icons/icon-component.vue";

@Options({
  components: {
    AppHeader,
    BrandLogo,
    LanguageSwitcher,
    BtnHome,
    BtnAudio,
    IconComponent,
  },
})
class EmptyHeader extends Vue {
  timeInterval!: ReturnType<typeof setTimeout>;

  time = "";

  get fallbackLogo(): string | null {
    return this.$getImage("filoxenia logo.png", null);
  }

  mounted(): void {
    this.updateTime();
    this.timeInterval = setInterval(() => this.updateTime(), this.$second(1));
  }

  updateTime(): void {
    this.time = getFullTimeFormat(new Date());
  }

  unmounted(): void {
    clearInterval(this.timeInterval);
  }
}
export default EmptyHeader;
</script>
<style lang="scss" scoped>
@import "@/assets/sass/variables.scss";
</style>
